import { createFileRoute } from '@tanstack/react-router'

import { LABELS } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/partners'
)({
  meta: () => [{ title: LABELS.PARTNER }]
})
